import { useMemo } from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { messages } from '../i18n/messages';
import { TestCycleTypesFromConfig } from '@oneaudi/vtp-configuration-service';
export const useRangeTestCycleEntriesLookup = () => {
    const wltpLabels = messages.testCycleLabels.wltp;
    const wltpCityLabel = useI18n(wltpLabels.rangeCity);
    const wltpCombinedLabel = useI18n(wltpLabels.rangeCombined);
    const wltpLabelsArray = useMemo(() => [
        { key: 'city', label: wltpCityLabel },
        { key: 'combined', label: wltpCombinedLabel },
    ], [wltpCityLabel, wltpCombinedLabel]);
    return useMemo(() => new Map([
        [
            TestCycleTypesFromConfig.WLTP,
            wltpLabelsArray,
        ],
    ]), [wltpLabelsArray]);
};
